module.exports = __webpack_public_path__ + "static/media/lassen-ricard_logo.3b895c24.svg";